export const JOIN_FROM_MAP = {
  footer: '首页底部_立即加入',
  navigation: '顶部导航_账号申请',
  banner: '首页Banner_立即申请',
  bannerlogin: '首页Banner_登录_立即申请',
  login: '登录页_立即申请',
  peerevaluate: '同业评价_立即加入',
  float: '立即加入悬浮提示框', // 这个需要新增
};

export const LOGIN_FROM_MAP = {
  navigation: '顶部导航_登录',
  orders: '顶部导航_我的订单',
  message: '顶部导航_消息中心',
  banner: '首页Banner_登录',
  product_list_peer_price: '商品列表页_同业优惠价_登录可见', // 这个现在没有了
  prodcut_list_apply_now: '商品列表页_立即办理', // 这个现在没有了
  productdetail0peerprice: '商品详情页_同业优惠价_登录可见',
  productdetail_apply_now: '商品详情页_立即办理',
  productdetail_share: '商品详情页_分享商品', // 新增
  productdetail_send_email: '商品详情页_发送资料到邮箱', // 新增
  productdetail_print_material: '商品详情页_打印资料清单', // 新增
  productdetail_ask_question: '商品详情页_我要提问', // 新增
  productdetail_question_like: '商品详情页_问题点赞', // 新增
  productdetail_question_detail: '问题详情页', // 新增
  activity: '活动跳转到登陆', // 新增
  forget_password_back: '忘记密码返回', // 新增
  modify_password_success: '修改密码成功返回', // 新增
  buy_insurance: '立即投保跳转到登陆', // 新增
  order_share_applicant: '订单分享申请人', // 新增
  insurance_detail_share: '保险商品详情页_分享给顾客',
  activity_double_eleven: '双十一活动',
};

export const ENTER_PRODUCT_DETAIL = {
  destination_tab: '导航_目的地',
  destination_banner: '首页Banner_目的地',
  index_search: '首页Banner_搜索结果',
  index_first_letter: '首页Banner_搜索_首字母',
  index_activity: '首页_本月活动', // 新增
  index_multi: '首页_多年多次', // 新增
  index_elec: '首页_电子签',
  activity: '本月活动落地页',
  country_list_search: '国家列表_搜索结果', // 新增
  country_list_first_letter: '国家列表_搜索_首字母', // 新增
  country_list_destination: '国家列表_目的地', // 新增
  order_detail: '订单详情', // 新增
  sf_order_mail_list: '顺丰邮寄资料清单', // 新增
  simple_product: '常用商品',
  order_upload: '上传资料页',
  order_interview: '选择赴馆日期页',
  coupon_desc: '优惠卷描述',
  '618-2023': '2023-618活动',
};

export const ENTER_INSURANCE = {
  nav_insurance: '导航进入',
  index_section_insurance: '首页模块进入',
  side_insurance: '侧边栏进入',
  order_after_buy: '订单后置购买',
};



// WEBPACK FOOTER //
// ./src/maps/sensors-maps.js